import React from 'react';
import styled from 'styled-components';

import Link from 'components/Link';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Button from 'components/Button/Button';

import { color, media } from 'styles/utils';

const Container = styled.div`
  background-color: ${color('white')};
  border-radius: 0.5rem;
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 0px 2px 10px 0px #0000000d;
  ${media.max('md')} {
    flex-direction: column;
  }
`;

const StyledStack = styled(Stack)`
  padding-right: 2rem;
  ${media.max('md')} {
    padding-right: 0rem;
  }
`;

const StyledButton = styled(Button)`
  ${media.max('md')} {
    width: 100%;
    margin-top: 1rem;
  }
`;

export default function ReportVulnerability() {
  return (
    <Container>
      <StyledStack gap="1rem">
        <Text variant="f5" color="mediumTeal">
          If you discover a security vulnerability please contact us.
        </Text>
        <Text variant="smallestP" color="teal">
          Read our <Link to="/disclosure/">disclosure policy.</Link>
        </Text>
      </StyledStack>
      <StyledButton href="mailto:security@sleuth.io" variant="primary">
        Report a vulnerability ↗
      </StyledButton>
    </Container>
  );
}
